import { Address } from '@31third/common';
import { Chain } from './chain';
import { ChainTokenCheck } from './chain-token-check';
import { ChainTokenTradeableCategory } from '../enum';

export class ChainToken {
  id: string;
  address: Address;
  chain: Chain;
  enabled: boolean;
  automationEnabled: boolean;
  nativeToken: boolean;
  maxWeiImprecision: number;
  tradeable: boolean;
  checkedManually: Date;
  enzymeAsset: boolean;
  autoCreated: boolean;
  checks: ChainTokenCheck[];

  public getLatestCheck(): ChainTokenCheck | undefined {
    if (!this.checks?.length) {
      return undefined;
    }

    return this.checks.reduce((latest, current) => {
      return latest.creationDate > current.creationDate ? latest : current;
    }, this.checks[0]);
  }

  public getTradeableCategory(): ChainTokenTradeableCategory {
    const latestCheck = this.getLatestCheck();

    if (!latestCheck) {
      return ChainTokenTradeableCategory.UNKNOWN;
    }
    return latestCheck.getTradeableCategory();
  }
}
